import { render, staticRenderFns } from "./ScrollPageLayout.vue?vue&type=template&id=6d06313b&scoped=true"
import script from "./ScrollPageLayout.vue?vue&type=script&lang=js"
export * from "./ScrollPageLayout.vue?vue&type=script&lang=js"
import style0 from "./ScrollPageLayout.vue?vue&type=style&index=0&id=6d06313b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d06313b",
  null
  
)

export default component.exports